import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const servicePlanList: IMcAppType = {
  name: "servicePlanList_KRAKEN",
  path: "/my/service/plans",
  description: "View all plans",
  parameters: {
    properties: {},
  },
  navFlow: NavFlow.STANDARD,
  title: "View all plans",
  parent: Tab.MORE,

  conditions: {
    intent: "servicePlanList",
    customerType: CustomerType.kraken,
  },
};
